module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentStep === 0) ? _c('div', {
    staticClass: "f5 db mb3"
  }, [_c('label', {
    staticClass: "cera-round-pro fw6 db mb3 title",
    attrs: {
      "for": "redemptionCode"
    }
  }, [_vm._v("\n    Activation Code\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "f6 silver inter mb4"
  }, [_vm._v("\n    Enter your activation code below and click the red \"submit\" button\n    before continuing.\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group-flex flex flex-row mb2 w-100"
  }, [_c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "inter f6 input-reset w-40 ba db mr3 br2 code-input ttu",
    attrs: {
      "id": "redemptionCode",
      "type": "text",
      "placeholder": "Activation Code"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submit.apply(null, arguments)
      },
      "input": _vm.onChangeValue
    }
  }), _vm._v(" "), _c('ak-button', {
    attrs: {
      "newDisabled": !_vm.value,
      "newSecondary": "",
      "shadow": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      Submit\n    ")])], 1), _vm._v(" "), (_vm.$store.state.registration &&
    _vm.$store.state.activation &&
    _vm.$store.state.registration.redemption &&
    _vm.$store.state.activation.coverage &&
    _vm.showMessage) ? _c('code-message') : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a5ee4bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/forms/ActivationCode.vue
// module id = 671
// module chunks = 0